































































import { Component } from "vue-property-decorator";
import { Route } from "vue-router";
import { NullableString } from "@/code/Types";
import { BreadCrumb } from "@/store/modules/GlobalStore";
import { Pages } from "@/enums/Pages";
import { accountStore } from "@/store/modules/AccountStore";
import { OpportunityData } from "@/models/OpportunityData";
import { opportunityStore } from "@/store/modules/OpportunityStore";
import BasePage from "../base/BasePage";
import Header from "@/views/ExistingPoliciesNoFeed/Home/Header.vue";
import { Routes } from "@/router/Routes";
import { Helpers } from "@/code/Helpers";

@Component({
  components: {
    Header,
  },
})
export default class extends BasePage {
  page = Pages.EXISTING_POLICIES;
  title = "Existing Policies (No Feeds)";
  search: NullableString = null;
  breadCrumbs = [new BreadCrumb("InForces")];
  dialog = false;

  headers = [
    { text: "Insured Name", value: "clientFullName" },
    { text: "Product Group", value: "opportunityProductLine" },
    { text: "Carrier", value: "insurance" },
    { text: "Product", value: "productType" },
    { text: "Face", value: "faceAmount" },
    { text: "Premium", value: "annualizedPremium" },
    {
      text: "Effective Date",
      value: "",
      sort: (a: NullableString, b: NullableString): number =>
        Helpers.sortDate(a, b),
    },
    { text: "Financial Advisor", value: "agentFullName" },
  ];

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: () => void
  ): Promise<void> {
    await opportunityStore.getAll();
    next();
  }
  get AllCase(): OpportunityData[] {
    return opportunityStore.inForceEntities;
  }
  get agentFullName(): NullableString | undefined {
    return accountStore.user?.agentFullName;
  }
  async showCaseDetail(id: string): Promise<void> {
    await this.$router.push({
      name: Routes.NEW_BUSINESS_CASE_DETAIL,
      params: { id },
    });
  }
}
